import { Expense } from "@finway-group/shared/lib/models"
import React from "react"
import { useTranslation } from "react-i18next"

import { formatExpenseDate } from "../../../../../shared/utils/date.utils"
import { DateListElement } from "./dateListElement"

interface PerformanceDateFieldProps {
    expense: Expense
}

export const PerformanceDateField = ({ expense }: PerformanceDateFieldProps) => {
    const { t } = useTranslation()

    if (!expense.performancePeriodStartDate) {
        return null
    }

    if (expense.performancePeriodStartDate === expense.performancePeriodEndDate) {
        return (
            <DateListElement
                title={t("info:cannot_be_transferred_to_datev")}
                label={`${t("label:performance_date")}*`}
                date={formatExpenseDate(expense.performancePeriodStartDate)}
            />
        )
    }

    return (
        <>
            <DateListElement
                title={t("info:cannot_be_transferred_to_datev")}
                label={`${t("label:performance_period_start_date")}*`}
                date={formatExpenseDate(expense.performancePeriodStartDate)}
                style={{ marginLeft: "10px", minWidth: "85px" }}
            />
            <DateListElement
                title={t("info:cannot_be_transferred_to_datev")}
                label={`${t("label:performance_period_end_date")}*`}
                date={formatExpenseDate(expense.performancePeriodEndDate)}
                style={{ marginLeft: "10px", minWidth: "85px" }}
            />
        </>
    )
}
